import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";

window.onVacanciesClose = () => {
  updateMeta(true);
  if ($('.js--vacancy-form').hasClass('d-none') && $('.js--vacancy-success').hasClass('d-none')) {
    clearModalContent()
    setUrlCategoryVacancyParam(null);
    toggleOverflowHidden(false);

    $('.js--vacancy-form, .js--vacancy-success').addClass('d-none');
    $('.js--vacancy-information').removeClass('d-none');
    clearForm();
  } else {
    $('.js--vacancy-form, .js--vacancy-success').addClass('d-none');
    $('.js--vacancy-information').removeClass('d-none');
    clearForm();
  }
}


window.onVacanciesOpen = (slug = null, meta_title = '', meta_description = '') => {
  if (slug) {
    setUrlCategoryVacancyParam(slug, 'vacancy')
  } else {
    setUrlCategoryVacancyParam(null, 'vacancy')
  }

  let contentDiv = document.getElementById(slug);
  if (contentDiv) {
    const information = contentDiv.querySelector('.js-global-vacancy-content');
    const title = contentDiv.querySelector('.js-global-vacancy-title');
    const image = contentDiv.querySelector('.js-global-vacancy-image');
    const categories = contentDiv.querySelector('.js--global-vacancy-categories');
    if (information) {
      updateModal('#vacancy-modal-wrapper', '.js-timeline-block-modal-content', information.innerHTML);
    }
    if (categories) {
      updateModal('#vacancy-modal-wrapper', '.js-timeline-categories', categories.innerHTML);

      if ($('.js-timeline-categories .category').length > 1) {
        $('.js--vacancy-dropdown').removeClass('disabled');
        $('.js--vacancy-dropdown .dropdown-value').text($('.js--vacancy-dropdown .dropdown-value').data('base-value'));
        $('.js--vacancy-selector-input').val('')
      } else {
        $('.js--vacancy-dropdown').addClass('disabled');
        $('.js--vacancy-dropdown .dropdown-value').text(title.textContent );
       const vacancyId = $(`[data-vacancy-title="${title.textContent}"]`).data('vacancy-id');

        $('.js--vacancy-selector-input').val(vacancyId )
      }
    }
    if (title) {
      updateModal('#vacancy-modal-wrapper', '.js-timeline-block-modal-bold-title', title.innerHTML);
    }
    if (image) {
      updateModal('#vacancy-modal-wrapper', '.js-timeline-block-modal-image', generateImageBlockHtml(image.src, title.innerHTML));
    } else {
      updateModal('#vacancy-modal-wrapper', '.js-timeline-block-modal-image', '');
    }

    updateMeta(false, meta_title, meta_description, false);
    setupModalOpen('#vacancy-modal-wrapper');
    window.initPopupDivider();
  }
}

$('body').on('click', '.js--vacancy-information .text-with-header button', function (event) {
  event.preventDefault();
  $('.inner-children').scrollTop(0);
  $('.js--vacancy-form').removeClass('d-none');
  $('.js--vacancy-information, .js--vacancy-success').addClass('d-none');
});

const updateModal = (modal, selector, content) => {
  $(`${modal} .inner-children ${selector}`).html(content);
}

const scrollToTopOfModal = (modalSelector) => {
  $(`${modalSelector} .inner-children`).scrollTop(0);
}

const setupModalOpen = (modalSelector) => {
  const modal = $(modalSelector)
  scrollToTopOfModal(modalSelector);
  modal.addClass('modal-active');
  toggleOverflowHidden(true);
  initBasicCarousel();
  initBlocksSwiper();
  initImageWithTextSlider();
}

const setUrlCategoryVacancyParam = (slug, type = 'vacancy') => {
  const newUrl = new URL(window.location.href);

  if (slug) {
    newUrl.searchParams.set(type, slug);
  } else {
    newUrl.searchParams.delete(type);
  }

  window.history.pushState({}, '', newUrl);
}

const clearModalContent = () => {
  const modal = $('.js-timeline-block-modal')
  modal.removeClass('modal-active');
  updateModal('.js-timeline-block-modal-content', '');
  updateModal('.js-timeline-block-modal-image', '');
  updateModal('.js-timeline-block-modal-bold-title', '');
}

const toggleOverflowHidden = (is_on = false) => {
  if (is_on) {
    $('body').addClass('overflow-hidden');
    $('html').addClass('overflow-hidden');
    smoothScrollPause();
  } else {
    $('body').removeClass('overflow-hidden');
    $('html').removeClass('overflow-hidden');
    smoothScrollPlay();
  }
}

const clearForm = () => {
  if (!$('.js--vacancy-dropdown').hasClass('disabled')) {
    $('.js--vacancy-dropdown .dropdown-value').text($('.js--vacancy-dropdown .dropdown-list .initial-value').text());
    $('.js--vacancy-dropdown .dropdown-list .option').removeClass('active');
    $('.js--vacancy-form input').val('');
  }
  $('.js--styled-file-upload .file-info').removeClass('active');
  $('.js--vacancy-form input[type="checkbox"]').prop('checked', false);
  $('.form-error.oc-visible').removeClass('oc-visible').text('');
}

window.onVacancySubmitSuccess = () => {
  $('.js--vacancy-success').removeClass('d-none');
  $('.js--vacancy-form').addClass('d-none');
  clearForm();
}

jQuery(document).ready(function ($) {
  $('.js--vacancy-dropdown').click(function (event) {
    if (!$(this).hasClass('disabled')) {
      $(this).addClass('active-dropdown');
    }
  });

  $('.js--vacancy-dropdown .dropdown-list .option').click(function (event) {
    event.stopPropagation();
    $('.js--vacancy-dropdown .dropdown-list .option').removeClass('active');
    $(this).addClass('active');
    $('.js--vacancy-dropdown .dropdown-value').text($(this).text());
    $('.js--vacancy-selector-input').val($(this).data('vacancy-id')).change();
    $('.js--vacancy-dropdown').removeClass('active-dropdown');
    $('[data-validate-for="vacancy"]').removeClass('oc-visible').text('');

  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.js--vacancy-dropdown').length) {
      $('.js--vacancy-dropdown').removeClass('active-dropdown');
    }
  });
});




